import { decimal } from '@snap-types/schemas/decimal';
import { z } from 'zod/v4';

import { originalSourceSchema } from '../enums';
import {
  partEngineeringStatusSchema,
  partEngineeringTypeSchema,
} from './enums';

export const columns = {
  id: z.string(),
  type: partEngineeringTypeSchema,
  baseId: z.string(),
  lotId: z.string(),
  splitId: z.string(),
  subId: z.string(),
  status: partEngineeringStatusSchema,
  desiredQuantity: decimal,
  receivedQuantity: decimal.nullable(),
  drawing: z.string().nullable(),
  drawingRevision: z.string().nullable(),
  estimatedMaterialCost: decimal.nullable(),
  estimatedLaborCost: decimal.nullable(),
  estimatedBurdenCost: decimal.nullable(),
  estimatedServiceCost: decimal.nullable(),
  actualMaterialCost: decimal.nullable(),
  actualLaborCost: decimal.nullable(),
  actualBurdenCost: decimal.nullable(),
  actualServiceCost: decimal.nullable(),
  closeDate: z.date().nullable(),
  costedDate: z.date().nullable(),
  engineeredDate: z.date().nullable(),

  originalSource: originalSourceSchema,

  partId: z.string().nullable(),
  partOriginalSource: originalSourceSchema.nullable(),

  siteId: z.string(),

  createdById: z.string().nullable(),

  createdByService: z.string().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
};
